module.exports = __webpack_public_path__ + "static/media/me.1e47b9c9.png";